import v from "@/lib/validator";
import { TFunction } from "i18next";

const RegistrarUserSchema = (translate: TFunction) => {
    const requiredValidation = v.methods().required({message: translate('profileForm.inputs.errorsMessages.required')})
    const permsRequiredValidation = v.methods().required({message: translate('profileForm.inputs.errorsMessages.requiredPerms')})

    return v.object({
        nome: requiredValidation,
        permissoes: permsRequiredValidation
    })
}
    
export default RegistrarUserSchema